var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _rect4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 63,
    viewBox: "0 0 200 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.6285,
    y: 8.57617,
    width: 43.9763,
    height: 43.9763,
    fill: "#1EB65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.548 28.9302L131.397 53.8897H115.7L123.548 28.9302Z",
    fill: "#FBFBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 148.062,
    y: 8.57617,
    width: 43.9763,
    height: 43.9763,
    fill: "#1EB65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.753 35.9129L192.038 26.6491L192.038 45.1767L169.753 35.9129Z",
    fill: "#FBFBFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1956,
    y: 8.57617,
    width: 43.9763,
    height: 43.9763,
    fill: "#1EB65B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2123 40.5189L95.1718 32.6703L95.1718 48.3674L70.2123 40.5189Z",
    fill: "#FBFBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2123 21.7986L95.1718 13.9501L95.1718 29.6472L70.2123 21.7986Z",
    fill: "#FBFBFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.533203,
    y: 52.5522,
    width: 43.9763,
    height: 45.9077,
    transform: "rotate(-90 0.533203 52.5522)",
    fill: "#1EB65B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3326 32.8335L26.8058 8.20819L41.8595 8.20819L34.3326 32.8335Z",
    fill: "#FBFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0187 32.8335L7.4918 8.20819L22.5455 8.20819L15.0187 32.8335Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.497c4e62aad90c64ab528972d9def822.svg";
export { ForwardRef as ReactComponent };